import { Routes } from '@angular/router';

import { RunningComponent } from './running/running.component';
import { LogsComponent } from './logs/logs.component';
import { UserRouteAccessService } from './core/auth/user-route-access-service';
import { errorRoute } from './layouts/error/error.route';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'deployments',
    pathMatch: 'full'
  },
  {
    path: 'running',
    component: RunningComponent,
    data: {
      userRoles: ['ADMIN', 'USER'],
      pageTitle: 'FDE - Financial Data Extractor'
    },
    canActivate: [UserRouteAccessService]
  },
  {
    path: 'logs',
    component: LogsComponent,
    data: {
      userRoles: ['ADMIN', 'USER'],
      pageTitle: 'FDE - Runner logs'
    },
    canActivate: [UserRouteAccessService]
  },
  {
    path: '',
    loadChildren: () => import('./account/account.module').then(m => m.FdeGatewayAccountModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.FdeGatewayAdminModule)
  },
  {
    path: '',
    loadChildren: () => import('./entities/entity.module').then(m => m.FdeGatewayEntityModule)
  },
  ...errorRoute
];
